import { storableError } from '../../util/errors';
import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { fetchOrganizationProfiles } from '../../ducks/organizations.duck';
import config from '../../config';

export const QUERY_EXPERIENCES_REQUEST = 'app/QuickRepliesPage/QUERY_EXPERIENCES_REQUEST';
export const QUERY_EXPERIENCES_SUCCESS = 'app/QuickRepliesPage/QUERY_EXPERIENCES_SUCCESS';
export const QUERY_EXPERIENCES_ERROR = 'app/QuickRepliesPage/QUERY_EXPERIENCES_ERROR';

// ================ Reducer ================ //

const initialState = {
  liveRoomIds: [],
  queryLiveRoomsInProgress: false,
  queryLiveRoomsLoaded: false,
  queryLiveRoomsError: null,
};

const resultIds = data => data.data.map(d => d.id);

export default function scheduleMessagesReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case QUERY_EXPERIENCES_REQUEST:
      return {
        ...state,
        queryLiveRoomsInProgress: true,
        queryLiveRoomsError: null,
      };
    case QUERY_EXPERIENCES_SUCCESS:
      return {
        ...state,
        liveRoomIds: resultIds(payload.data),
        queryLiveRoomsInProgress: false,
        queryLiveRoomsLoaded: true,
        queryLiveRoomsError: null,
      };
    case QUERY_EXPERIENCES_ERROR:
      return {
        ...state,
        liveRoomIds: [],
        queryLiveRoomsInProgress: false,
        queryLiveRoomsError: payload,
      };

    default:
      return state;
  }
}

// ================ Action creators ================ //

export const queryExperiencesRequest = () => ({
  type: QUERY_EXPERIENCES_REQUEST,
});
export const queryExperiencesSuccess = response => ({
  type: QUERY_EXPERIENCES_SUCCESS,
  payload: { data: response.data },
});
export const queryLiveRoomsError = e => ({
  type: QUERY_EXPERIENCES_ERROR,
  error: true,
  payload: e,
});

// ================ Thunk ================ //

export const queryExperiences = () => (dispatch, getState, sdk) => {
  dispatch(queryExperiencesRequest());

  return sdk.currentUser.show().then(response => {
    const currentUser = response.data.data;

    return sdk.listings
      .query({
        authorId: currentUser.id,
        pub_type: config.listingTypes['live-room'],
      })
      .then(response => {
        dispatch(addMarketplaceEntities(response));
        dispatch(queryExperiencesSuccess(response));
        return response;
      })
      .catch(e => dispatch(queryLiveRoomsError(storableError(e))));
  });
};

export const loadData = () => (dispatch, getState, sdk) => {
  return Promise.all([dispatch(queryExperiences()), dispatch(fetchOrganizationProfiles())]);
};
